class GTurboProductUpsell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.recommendationsPerformed === 'true') {
      return;
    }

    this.load_recommendations();
  }

  async load_recommendations() {
    const product_id = this.dataset.productId;
    const section_id = this.dataset.sectionId;
    const intent = this.dataset.intent;
    const base_url = this.dataset.url;

    if (!product_id || !section_id || !base_url) {
      this.hidden = true;
      return;
    }

    const url = `${base_url}&product_id=${product_id}&section_id=${section_id}&intent=${intent}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        this.hidden = true;
        return;
      }

      const html = await response.text();
      const parsed_html = new DOMParser().parseFromString(html, 'text/html');
      const updated_block = parsed_html.getElementById(this.id);
      const has_product_card = updated_block?.querySelector('.gturbo-upsell-products__card');

      if (!updated_block || !has_product_card) {
        this.hidden = true;
        return;
      }

      this.innerHTML = updated_block.innerHTML;
      this.dataset.recommendationsPerformed = 'true';
      this.hidden = false;
    } catch (error) {
      console.error('GTurbo product upsell error:', error);
      this.hidden = true;
    }
  }
}

if (!customElements.get('gturbo-product-upsell')) {
  customElements.define('gturbo-product-upsell', GTurboProductUpsell);
}
